import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ColumnsService } from 'app/private/sxfdesigner/services/columns-service';
import { ColumnsAttribute } from 'app/private/sxfdesigner/types/designer-attribute-type';

@Component({
    selector: 'app-columns-modal-general',
    templateUrl: 'columns-modal-general.component.html'
})
export class SxColumnsModalGeneralComponent implements OnInit, OnDestroy {

    readonly DEFAULT_COLOR = '#ffffff';
    @Input()
    item: ColumnsAttribute;
    distributions: any[];
    radioColumns: string;
    radioDistributions:string;
    selectedColumns: number;
    selectedDistribution: number;
    columns = [1, 2, 3, 4];
    type: string;

    changeSubscription: any;

    constructor(private columnsService: ColumnsService) {
        this.columnsService.advancedColumns$.subscribe(a => this.typeChanged('custom'));
        this.type = 'predefined';
    }

    ngOnInit(): void {
        // When item changes (save button pressed), post to the columnAtt the current columnValue
        this.changeSubscription = this.item.change.subscribe(c => this.item.onSave.next(this.columnsService.getColumnsValue()));
        // Retrieves the current value of the item
        this.changedColumn(this.columns[0].toString());
        const initialValue = this.item.onRaise.getValue();

        if (initialValue != null) {
            let stringedDistribution = '';
            initialValue.forEach(element => {
                stringedDistribution += element.width;
            });
            // check if there is a specifed distribution and if the color of all the columns is the default
            if (this.getColumnsByDistribution()[stringedDistribution] && initialValue.every(c => c.color === this.DEFAULT_COLOR)) {
                
                this.changedColumn(this.getColumnsByDistribution()[stringedDistribution]);

                const distr = this.distributions.find(d => d.value === parseFloat(stringedDistribution));

                for (let index = 0; index < initialValue.length; index++) {
                    distr.columns[index].color = initialValue[index].color;
                }

                this.distibutionChanged(stringedDistribution);

            } else {
                this.typeChanged('custom');
                this.columnsService.modifyGeneralColumns(initialValue);
            }
            
            this.setRadioButtons(initialValue,stringedDistribution);
        }
    }

    ngOnDestroy(): void {
        this.changeSubscription.unsubscribe();
    }

    setRadioButtons(initialValue : any, stringedDistribution: any) {
        this.radioColumns = initialValue.length.toString();
        this.radioDistributions = stringedDistribution;
        this.distributions = this.getDistributions()[initialValue.length]
    }

    changedColumn(columns: any) {
        this.selectedColumns = columns;
        this.type = 'predefined';
        this.distributions = this.getDistributions()[columns];

        this.selectedDistribution = this.distributions[0].value.toString();
        this.distibutionChanged(this.selectedDistribution);
    }

    createColumns(...widths) {
        const columns = new Array(widths.length);
        for (let index = 0; index < widths.length; index++) {
            columns[index] = { width: widths[index], color: this.DEFAULT_COLOR };
        }
        return columns;
    }

    distibutionChanged(distribution) {
        this.selectedColumns = this.getColumnsByDistribution()[distribution];
        this.type = 'predefined';
        const numberedDistribution = parseFloat(distribution);
        this.selectedDistribution = distribution;
        this.columnsService.modifyGeneralColumns(this.distributions.find(d => d.value === numberedDistribution).columns);
    }

    typeChanged(type) {
        this.type = type;
        if (type === 'custom') {
                this.selectedColumns = undefined;
                this.selectedDistribution = undefined;
        }
    }

    getDistributions() {
        return {
            1: [{ value: 12, description: '12', icon: '1', columns: this.createColumns(12) }],
            2: [
                { value: 66, description: '6 | 6', icon: '2', columns: this.createColumns(6, 6) },
                { value: 48, description: '4 | 8', icon: '2-2', columns: this.createColumns(4, 8) },
                { value: 84, description: '8 | 4', icon: '2-3', columns: this.createColumns(8, 4) },
            ],
            3: [
                { value: 444, description: '4 | 4 | 4', icon: '3', columns: this.createColumns(4, 4, 4) },
                { value: 363, description: '3 | 6 | 3', icon: '3-2', columns: this.createColumns(3, 6, 3) },
                { value: 282, description: '2 | 8 | 2', icon: '3-3', columns: this.createColumns(2, 8, 2) }
            ],
            4: [
                { value: 3333, description: '3 | 3 | 3 | 3', icon: '4', columns: this.createColumns(3, 3, 3, 3) },
                { value: 2442, description: '2 | 4 | 4 | 2', icon: '4-2', columns: this.createColumns(2, 4, 4, 2) },
                { value: 2424, description: '2 | 4 | 2 | 4', icon: '4-3', columns: this.createColumns(2, 4, 2, 4) }
            ]
        };
    }

    getColumnsByDistribution() {
        const res = {};
        Object.keys(this.getDistributions()).forEach(key => {
            for (let index = 0; index < this.getDistributions()[key].length; index++) {
                const value = this.getDistributions()[key][index].value;
                res[value] = key;
            }
        });
        return res;
    }

}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/modals/tabs/general/columns-modal-general.component.ts